/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { SearchParcelBySpiResultDto } from '../../models/search-parcel-by-spi-result-dto';

export interface SearchForParcelBySpi$Params {
  spi: string;
}

export function searchForParcelBySpi(
  http: HttpClient,
  rootUrl: string,
  params: SearchForParcelBySpi$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<SearchParcelBySpiResultDto>> {
  const rb = new RequestBuilder(rootUrl, searchForParcelBySpi.PATH, 'get');
  if (params) {
    rb.path('spi', params.spi, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SearchParcelBySpiResultDto>;
      }),
    );
}

searchForParcelBySpi.PATH = '/search/parcel/spi/{spi}';
